import React from "react";
import { useTranslation } from "react-i18next";
import "./ContactReassurance.css";

/**
 * Section 04 — Réassurance : étapes après une demande.
 * Présentation informative uniquement : aucun état du formulaire, aucune requête.
 * Traductions locales : ne modifie pas les fichiers i18n globaux validés.
 */
const CONTENT = {
  fr: {
    eyebrow: "03 / PROCHAINE ÉTAPE",
    title: "Que se passe-t-il ensuite ?",
    steps: [
      {
        id: "01",
        title: "Nous découvrons votre demande",
        text: "Votre besoin est transmis à l'équipe concernée."
      },
      {
        id: "02",
        title: "Nous échangeons sur votre projet",
        text: "Un échange permet de préciser votre contexte et vos contraintes."
      },
      {
        id: "03",
        title: "Nous proposons une suite adaptée",
        text: "Démonstration, étude ou réponse à votre question, selon le besoin."
      }
    ]
  },
  en: {
    eyebrow: "03 / NEXT STEPS",
    title: "What happens next?",
    steps: [
      {
        id: "01",
        title: "We review your enquiry",
        text: "Your request is directed to the relevant team."
      },
      {
        id: "02",
        title: "We discuss your project",
        text: "A conversation helps us understand your context and constraints."
      },
      {
        id: "03",
        title: "We suggest an appropriate next step",
        text: "A demonstration, assessment or answer to your question, as needed."
      }
    ]
  }
};

export default function ContactReassurance() {
  const { i18n } = useTranslation();
  const locale = (i18n.resolvedLanguage || i18n.language || "fr")
    .toLowerCase()
    .startsWith("en") ? "en" : "fr";
  const content = CONTENT[locale];

  return (
    <section className="contact-reassurance" aria-labelledby="contact-reassurance-title">
      <header className="contact-reassurance__header">
        <p className="contact-reassurance__eyebrow">{content.eyebrow}</p>
        <h2 id="contact-reassurance-title" className="contact-reassurance__title">
          {content.title}
        </h2>
      </header>

      <ol className="contact-reassurance__steps">
        {content.steps.map((step) => (
          <li key={step.id} className="contact-reassurance__item">
            <span className="contact-reassurance__number" aria-hidden="true">{step.id}</span>
            <div className="contact-reassurance__body">
              <h3 className="contact-reassurance__stepTitle">{step.title}</h3>
              <p className="contact-reassurance__stepText">{step.text}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
